import { AppPagination } from "@/components/commons/app-pagination"
import { AppSkeletonTable } from "@/components/commons/app-skeleton-table"
import { DataTable } from "@/components/ui/data-table"
import { useAccessManagement, useAccessManagementSearchParams } from "@/hooks"

import { accessManagementColumns } from "./columns"
export const AccessManagementTable = () => {
  const { params } = useAccessManagementSearchParams()
  const { data, isFetching } = useAccessManagement(params)
  const count = data?.count || 0
  const pagination = {
    currentPage: params.page,
    total: count,
    totalPages: Math.ceil(count / params.quantity),
  }
  if (isFetching) {
    return (
      <AppSkeletonTable
        withHeaderButton
        columns={accessManagementColumns.length}
      />
    )
  }
  return (
    <div className="space-y-4">
      <DataTable
        showColumnVisibility
        data={data?.users}
        columns={accessManagementColumns}
      />
      <AppPagination pagination={pagination} />
    </div>
  )
}
